import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Card, Form, message, Space, Spin, Table } from "antd";
import { RootState } from "../../redux/store"; // Import RootState type
import { API } from "../../config/api";
import { POST } from "../../utils/apicalls";
import moment from "moment";
import { GrView } from "react-icons/gr";
import { useNavigate } from "react-router-dom";

function Employee_Dashboard() {
  const user: any = useSelector((state: RootState) => state?.user); // Access user state
  const [UsersData, setUsersData] = useState<any[]>([]); // Ensure default value is an array
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(1500); // Define the page size
  const [Taskdata, setTaskData] = useState<any>([]);
  const [meta, setMeta] = useState<any>({});
  const [metas, setMetas] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getUserData();
  }, []); // Empty array to ensure the effect runs only on component mount

  const getUserData = async () => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query") || "", // Fallback in case query is undefined
        assignedTo: user.id || null, // Default to null if not provided
      };
      const url = API.PROJECT_LIST_EMPLOYEE;
      const response: any = await POST(url, obj);
      setUsersData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch user data. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    viewTaskData([]);
  }, []);

  const viewTaskData = async (values: any) => {
    try {
      setIsLoading(true);
      let obj = {
        page: page,
        take: pageSize,
        status: values.status,
        assignedTo: user.id,
      };
      const url = API.TASK_IN_PROJECT;
      const response: any = await POST(url, obj);
      setTaskData(response?.data);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch task data. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  // Calculate task counts
  const pendingTasksCount = Taskdata.filter(
    (task: any) => task.status === "pending"
  ).length;
  const completedTasksCount = Taskdata.filter(
    (task: any) => task.status === "completed"
  ).length;
  const inProgressTasksCount = Taskdata.filter(
    (task: any) => task.status === "inprogerss"
  ).length;

  const columns = [
    {
      key: "projectName",
      dataIndex: "projectName",
      title: "Project Name",
      render: (projectName: string) => <span>{projectName}</span>,
    },
    {
      key: "projectType",
      dataIndex: "projectType",
      title: "Project Type",
      render: (projectType: string) => <span>{projectType}</span>,
    },
    {
      key: "startDate",
      dataIndex: "startDate",
      title: "Start Date",
      render: (startDate: string) => (
        <span>{moment(startDate).format("YYYY-MM-DD")}</span>
      ),
    },
    {
      key: "endDate",
      dataIndex: "endDate",
      title: "End Date",
      render: (endDate: string) => (
        <span>{moment(endDate).format("YYYY-MM-DD")}</span>
      ),
    },
    {
      key: "status",
      dataIndex: "status",
      title: "Status",
      render: (status: string) => <span>{status}</span>,
    },
    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() => navigate(`/Employee/project_view/${record?.id}`)}
          />
        </Space>
      ),
    },
  ];
  console.log("object", Taskdata);
  if (!user) {
    return <Spin tip="Loading employee details..." />;
  }

  return (
    <>
      <Card
        title="Employee Dashboard"
        style={{ margin: "20px", textAlign: "center" }}
      >
        <div
          style={{
            display: "flex",
            gap: "16px",
            padding: "20px",
            justifyContent: "center",
          }}
        >
          <Card onClick={() => navigate(`/Employee/Project_Details`)}>
            Total Projects: <b>{UsersData?.length}</b>
          </Card>
          <Card
            onClick={() =>
              navigate(`/Employee/Project_Details`, {
                state: { status: "pending", tasks: Taskdata },
              })
            }
          >
            Pending Tasks: <b>{pendingTasksCount}</b>
          </Card>
          <Card
            onClick={() =>
              navigate(`/Employee/Project_Details`, {
                state: { status: "completed", tasks: Taskdata },
              })
            }
          >
            Completed Tasks: <b>{completedTasksCount}</b>
          </Card>
          <Card
            onClick={() =>
              navigate(`/Employee/Project_Details`, {
                state: { status: "inprogress", tasks: Taskdata },
              })
            }
          >
            In Progress Tasks: <b>{inProgressTasksCount}</b>
          </Card>
        </div>
      </Card>
      <h2 style={{ textAlign: "center" }}>TOTAL PROJECT DETAILS</h2>
      <Table
        columns={columns}
        dataSource={UsersData}
        rowKey={(record: any) => record.id}
        pagination={{ pageSize: 5 }}
        loading={isLoading}
      />
    </>
  );
}

export default Employee_Dashboard;
